import { useState } from 'react';
import './App.css';
import { ChatInterface } from './components/ChatInterface';

function App() {
  const [darkMode, setDarkMode] = useState(true);

  return (
    <div className="App" data-theme={darkMode ? 'dark' : 'light'}>
      <ChatInterface darkMode={darkMode} toggleDarkMode={() => setDarkMode((d) => !d)} />
    </div>
  );
}

export default App;
